import QuickActions from "./QuickActions";

export default function QuickActionsWrap() {

  return (
    <>
      <QuickActions />
    </>
  )
}